﻿import ajaxPartials from './ajax-partials.js';

export function eventFilters(element) {

    if (!element) 
        return;
    
    const init = function () {

        const form = element.querySelector('form');
        const target = document.querySelector(form.getAttribute('data-ajax-updateelement'));

        if (!target)
            return;

        const submitForm = function (updateHistory) {
            target.innerHTML = '';

            ajaxPartials.addLoader(target);
                        
            const formData = new FormData(form);            
            fetch(form.getAttribute('action'), {
                method: form.getAttribute('method'),
                body: formData
            }).then(result => result.text()).then(function (html) {
                target.innerHTML = html;
                ajaxPartials.removeLoader(target);
            }).catch(function (err) {
                console.warn('Something went wrong.', err);
                ajaxPartials.removeLoader(target);
            });

            if (!updateHistory) 
                return;

            // Convert to querystring and clean up
            const params = new URLSearchParams(formData);
            
            var pageIndex = parseInt(params.get('pageIndex'));
            if (!isNaN(pageIndex) && pageIndex > 0)
                params.set('p', pageIndex + 1);

            // These should never go in url as they are set from server
            params.delete('pageIndex');
            params.delete('pageSize');
            params.delete('parentContentId');
            params.delete('searchResultMaxTextLength');

            // Remove empty params
            let keysForDel = [];
            params.forEach((value, key) => {
                if (value == '') {
                    keysForDel.push(key);
                }
            });

            keysForDel.forEach(key => {
                params.delete(key);
            });

            if ([...params].length > 0) {
                window.history.pushState(null, '', window.location.pathname + '?' + params.toString());
            } else {
                window.history.pushState(null, '', window.location.pathname);
            }            
        };

        // Period (date) buttons
        form.querySelectorAll('button[data-from-date]').forEach(element => {
            element.addEventListener('click', evt => {

                evt.preventDefault();

                if (!evt.target)
                    return;

                var dateStart = evt.target.getAttribute('data-from-date');
                var dateEnd = evt.target.getAttribute('data-to-date');

                form.querySelector('input[name="fromDate"]').value = dateStart;
                form.querySelector('input[name="toDate"]').value = dateEnd;
            });
        });

        // Filter dropdowns        
        form.addEventListener('hide.bs.dropdown', evt => {

            const button = evt.target;
            const dropdown = button.parentNode;

            button.classList.remove('active-child');
            dropdown.querySelectorAll('input[type="checkbox"]').forEach(element => {
                if (element.checked) {
                    button.classList.add('active-child');
                    return;
                }
            });
        });

        form.querySelectorAll('input[type="checkbox"][name^="selectedFilters."]').forEach(element => {
            element.addEventListener('change', evt => {
                // Timeout to emulate "after"
                setTimeout(function () { submitForm(true); }, 1);      
            });
        });


        // Hi-jack the form submit
        form.addEventListener('submit', function (evt) {
            evt.preventDefault();

            submitForm(true);            
        });

        form.addEventListener('reset', function (evt) {
            //// Timeout to emulate "after"
            //setTimeout(function () { submitForm(true); }, 1);

            //// Remove active state
            //form.querySelectorAll('button.dropdown-toggle.active-child').forEach(element => {
            //    element.classList.remove('active-child');
            //});

            // If page was accessed with params in querystring a simple reset
            // will not clear the form. An easy workaround is to simply reload the
            // page without query.
            evt.preventDefault();
            window.location = window.location.pathname;
        });

        // First load, trigger a submit to load results
        submitForm(false);
    };
    
    init();    
}